"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    zoom: 'זום'
  },
  ar: {
    close: 'تكبير'
  },
  en: {
    close: 'Zoom'
  }
};